import {Observable, Subscription} from 'rxjs';

import logger                      from '../../../Shared/Util/logger';
import IPlaybackQuality            from '../../../Solutions/Shared/Interfaces/IPlaybackQuality';
import IPlayerStateManagerResolver from '../Interfaces/IPlayerStateManagerResolver';

const subscribeToPlaybackQualityChange = (
    playbackQualityChange$: Observable<IPlaybackQuality>,
    getPlayerStateManager: IPlayerStateManagerResolver
): Subscription =>
    playbackQualityChange$
        .subscribe((playbackQuality: IPlaybackQuality) => {
            const playerStateManager = getPlayerStateManager();
            const bitrateKbps = Math.round(playbackQuality.bitrate / 1000);
            const [width, height] = playbackQuality.resolution.split('x').map(resolution => Number(resolution));

            if (bitrateKbps === 0) return;

            const currentBitrateKbps = playerStateManager.getBitrateKbps();
            // @ts-ignore
            const currentHeight = playerStateManager._height;

            if (currentBitrateKbps !== bitrateKbps) {
                playerStateManager.setBitrateKbps(bitrateKbps);

                logger.log(`[Conviva] Bitrate changed: ${bitrateKbps}`);
            }

            if (currentHeight !== height) {
                playerStateManager.setVideoResolutionHeight(height);
                playerStateManager.setVideoResolutionWidth(width);

                logger.log(`[Conviva] Resolution changed: ${playbackQuality.resolution}`);
            }
        });

export default subscribeToPlaybackQualityChange;